import { render, staticRenderFns } from "./LmSubTitle.vue?vue&type=template&id=41f18cc4&scoped=true"
import script from "./LmSubTitle.vue?vue&type=script&lang=js"
export * from "./LmSubTitle.vue?vue&type=script&lang=js"
import style0 from "./LmSubTitle.vue?vue&type=style&index=0&id=41f18cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f18cc4",
  null
  
)

export default component.exports